import axios from "axios";
import { API_BASE_URL } from "../config/config";

// const currentDomain = window.location.hostname; // Örn: "localhost" veya "www.example.com"

// // API URL'sini dinamik olarak ayarlamak

// const API_BASE_URL =
//   currentDomain === "localhost" ||
//   currentDomain === "127.0.0.1" ||
//   currentDomain === "aiconnect.com.tr" ||
//   currentDomain === "demo.aiconnect.com.tr"
//     ? "https://apis.aiconnect.com.tr/numberpool"
//     : `https://apis.${currentDomain}/numberpool`;

const AgentBreakLogService = {
  list: (data) => {
    const params = new URLSearchParams({
      start: data.start,
      size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
      lang: data.userLang,
    });
    return axios.get(`${API_BASE_URL}/numberpool/list?${params.toString()}`);
  },

  detail: (data) => {
    const params = new URLSearchParams({
      start: data.start,
      size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
      accountid: data.accountid,
      numberpool: data.numberpool,
      lang: data.userLang,
    });
    return axios.get(`${API_BASE_URL}/numberpool/detail?${params.toString()}`);
  },

  downloadAll: (data) => {
    const params = new URLSearchParams({
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
      numberpoolId: data.numberpoolId,
    });
    return axios.get(
      `${API_BASE_URL}/numberpool/reportDownloadAll?${params.toString()}`
    );
  },

  addnew: (data) => {
    return axios.post(`${API_BASE_URL}/numberpool/addnew`, data);
  },
  insertMultiple: (data) => {
    return axios.post(`${API_BASE_URL}/numberpool/insert`, data);
  },
  delete: (data) => {
    return axios.post(`${API_BASE_URL}/numberpool/delete`, data);
  },
  isactive: (data) => {
    return axios.post(`${API_BASE_URL}/numberpool/isactive`, data);
  },
  pooldata: (data) => {
    return axios.post(`${API_BASE_URL}/numberpool/pooldata`, data);
  },
  updatepool: (data) => {
    return axios.post(`${API_BASE_URL}/numberpool/updatepool`, data);
  },
  isProgressive: (data) => {
    return axios.post(`${API_BASE_URL}/numberpool/isProgressive`, data);
  },
  getSmsData: (data) => {
    return axios.post(`${API_BASE_URL}/numberpool/getSmsData`, data);
  },
};

export default AgentBreakLogService;
